export enum FreeTextFormat {
    Text = 0,
    Number = 1,
    Date = 2,
    Time = 3,
    CountryCode
}
